import { createFileRoute } from '@tanstack/react-router';
import { useTranslation } from 'react-i18next';

import { AuthCard } from '../../features/auth/components/AuthCard';
import { ResetPasswordForm } from '../../features/auth/components/ResetPasswordForm';
import { PublicLayout } from '../../layouts/PublicLayout';
import { tokenParam } from '../../lib/search';

/* Spec 12.1: `/reset-password?token`. Absent or empty is handled by the form. */
export const Route = createFileRoute('/$lang/reset-password')({
  validateSearch: (search: Record<string, unknown>) => ({ token: tokenParam(search['token']) }),
  component: ResetPasswordScreen,
});

function ResetPasswordScreen(): React.ReactNode {
  const { lang } = Route.useParams();
  const { token } = Route.useSearch();
  const { t } = useTranslation();

  return (
    <PublicLayout lang={lang}>
      <AuthCard title={t('auth.resetPassword.title')} subtitle={t('auth.resetPassword.subtitle')}>
        <ResetPasswordForm lang={lang} token={token} />
      </AuthCard>
    </PublicLayout>
  );
}
